<template>
  <div id="page-tipos-productos-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">

        <!-- REXISTROS POR PÁXINA -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ productos.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : productos.length }} de {{ productos.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- BUSCA E EXPORTACIÓN A CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />
        <vs-button icon-pack="feather" icon="icon-download" color="primary" type="border" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv({ allColumns: true })">Exportar a CSV</vs-button>
        <vs-button icon-pack="feather" icon="icon-file-plus" class="ml-4 mr-4" :to="{ name: 'valProductosNuevo' }">Nuevo</vs-button>

      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="productos"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

      <div class="vx-col w-full flex">&nbsp;</div>

      <div class="vx-col w-full flex justify-end">
        <vs-button icon-pack="feather" icon="icon-user" class="mr-4" :to="{ name: 'valProductosNuevo' }">Nuevo</vs-button>
      </div>

    </div>

  </div>

</template>

<script>
// Store Module
import valProductosStore from '@/store/configuracion/val-productos/index.js'

import { AgGridVue } from 'ag-grid-vue'
import localeEs from '@/locale/aggrid/es.locale'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Cell Renderer
import CellRendererLink from './list-cell-renderer/CellRendererLink.vue'
import CellRendererActions from './list-cell-renderer/CellRendererActions.vue'
import CellRendererMonedaLink from './list-cell-renderer/CellRendererMonedaLink.vue'

export default {
  components: {
    AgGridVue,
    CellRendererMonedaLink,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    // eslint-disable-next-line no-undef
    CellRendererActions
  },
  data () {
    return {
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        localeTextFunc (key, defaultValue) {          
          return localeEs[key] || defaultValue
        }
      },
      params:  {        
        allColumns: true
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          headerTooltip: 'ID',
          field: 'id',
          filter: 'agNumberColumnFilter',
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: false,
          type: 'numericColumn'
        },
        {
          headerName: 'OPERADOR',
          headerTooltip: 'Operador',
          field: 'operador',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'TIPO_CLIENTE',
          headerTooltip: 'Tipo cliente',
          field: 'tipoCliente',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'TIPO_TARJETA',
          headerTooltip: 'Tipo de tarjeta en la pantalla de detalle de productos de una operación',
          field: 'tipoTarjeta',
          hide: true
        },
        {
          headerName: 'TIPO_PRODUCTO',
          headerTooltip: 'Tipo producto',
          field: 'tipoProducto',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'SECCION',
          headerTooltip: 'Sección',
          field: 'seccion',
          hide: true
        },
        {
          headerName: 'UNICO',
          headerTooltip: 'Producto único por SECCION y TIPO_PRODUCTO',
          field: 'unico',
          hide: true
        },
        {
          headerName: 'CODIGO_PRINCIPAL',
          headerTooltip: 'Código del producto principal',
          field: 'codigoPrincipal',
          hide: true
        },
        {
          headerName: 'ASOCIADOS',
          headerTooltip: 'Productos asociados al CODIGO_PRINCIPAL',
          field: 'asociados',
          hide: true
        },
        {
          headerName: 'ORDEN',
          headerTooltip: 'Número de ordenación del producto',
          field: 'orden',
          hide: true
        },
        {
          headerName: 'PRODUCTO',
          headerTooltip: 'Producto',
          field: 'producto',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'PROMOCION',
          headerTooltip: 'Promoción',
          field: 'promocion',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'IMPORTE_SIN_PROMOCION',
          headerTooltip: 'Importe sin promoción',
          field: 'importeSinPromocion',
          filter: 'agNumberColumnFilter',
          cellRendererFramework: 'CellRendererMonedaLink',
          type: 'numericColumn'
        },
        {
          headerName: 'IMPORTE_CON_PROMOCION',
          headerTooltip: 'Importe con promoción',
          field: 'importeConPromocion',
          filter: 'agNumberColumnFilter',
          cellRendererFramework: 'CellRendererMonedaLink',
          type: 'numericColumn'
        },
        {
          headerName: 'CARACTERISTICAS',
          headerTooltip: 'Características',
          field: 'caracteristicas',
          hide: true
        },
        {
          headerName: 'Acciones',
          field: 'transactions',
          width: 100,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererMonedaLink,
        CellRendererActions
      }
    }
  },
  computed: {
    productos () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      return this.$store.state.valProductosStore.productos
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'Todos', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    try {
      if (!valProductosStore.isRegistered) {
        this.$store.registerModule('valProductosStore', valProductosStore)
        valProductosStore.isRegistered = true
      }
      await this.$store.dispatch('valProductosStore/getProductos')
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
    } catch (error) {
      console.error(error)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridApi.sizeColumnsToFit()

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
}

</script>

<style lang="scss">
#page-productos-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
